// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"2b553c39","787":"933cf919","845":"684dc0ee","903":"75fb3ed4"}[chunkId] + ".chunk.js";
};